import {create} from 'zustand';
import {BookingPlanChangeState} from './types';

export const useBookingPlanChangeStore = create<BookingPlanChangeState>()(set => ({
	isComingFromBookingFlow: false,
	setIsComingFromBookingFlow: state => set({isComingFromBookingFlow: state}),
}));
